import React from "react";
import { TrendingUp, CheckCircle2, PhoneOff } from "lucide-react";

export const ROIResultsPanel = ({ results }) => (
  <div className="space-y-6">
    {/* Current losses */}
    <div className="bg-slate-900 border-2 border-slate-700 rounded-md p-6" style={{ boxShadow: "4px 4px 0px rgba(30, 90, 158, 0.2)" }}>
      <h3 className="flex items-center gap-2 text-lg font-bold text-white mb-5" style={{ fontFamily: "Barlow, sans-serif" }}>
        <PhoneOff className="w-5 h-5 text-slate-400" />
        Situation actuelle
      </h3>
      <div className="space-y-4">
        <Row label="Appels manques / semaine" value={results?.missedCallsPerWeek || "0"} dark />
        <div className="border-t border-slate-700" />
        <Row label="Urgences perdues / mois" value={results?.lostUrgenciesPerMonth || "0"} dark />
        <div className="border-t border-slate-700" />
        <div className="bg-slate-800 rounded-md p-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold text-slate-300">CA perdu</span>
            <div className="text-right">
              <p className="text-3xl font-black text-accent" style={{ fontFamily: "Barlow, sans-serif" }}>
                {results?.lostRevenue?.toLocaleString("fr-CH") || "0"} CHF
              </p>
              <p className="text-xs text-slate-500">par mois</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Gains with solution */}
    <div className="bg-white border-2 border-accent/30 rounded-md p-6" style={{ boxShadow: "4px 4px 0px rgba(249, 115, 22, 0.15)" }}>
      <h3 className="flex items-center gap-2 text-lg font-bold text-slate-900 mb-5" style={{ fontFamily: "Barlow, sans-serif" }}>
        <TrendingUp className="w-5 h-5 text-accent" />
        Avec la solution IA
      </h3>
      <div className="space-y-4">
        <Row label="Urgences recuperees / mois" value={`+${results?.recoveredUrgencies || "0"}`} accent />
        <div className="border-t border-slate-200" />
        <Row label="CA supplementaire" value={`+${results?.recoveredRevenue?.toLocaleString("fr-CH") || "0"} CHF`} accent />
        <div className="border-t border-slate-200" />
        <div className="bg-accent/10 rounded-md p-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold text-slate-700">ROI mensuel net</span>
            <div className="text-right">
              <p className="text-3xl font-black text-accent" style={{ fontFamily: "Barlow, sans-serif" }}>
                +{results?.monthlyROI?.toLocaleString("fr-CH") || "0"} CHF
              </p>
              <p className="text-xs text-slate-500">
                Soit {results?.yearlyROI?.toLocaleString("fr-CH") || "0"} CHF/an
              </p>
            </div>
          </div>
        </div>

        {results && results.roiRatio > 0 && (
          <div className="flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-md p-3">
            <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0" />
            <p className="text-sm font-semibold text-slate-700">
              Retour sur investissement de{" "}
              <span className="text-primary font-black">{results.roiRatio}%</span> par mois
            </p>
          </div>
        )}
      </div>
    </div>
  </div>
);

const Row = ({ label, value, dark, accent }) => (
  <div className="flex justify-between items-center">
    <span className={`text-sm ${dark ? "text-slate-400" : "text-slate-600"}`}>{label}</span>
    <span className={`text-2xl font-black ${accent ? "text-accent" : "text-white"}`} style={{ fontFamily: "Barlow, sans-serif" }}>
      {value}
    </span>
  </div>
);
